import React, { useState } from 'react';
import { Flex, Grid, Text, Title } from '@mantine/core';
import useFetch from '../../helpers/useFetch';
import ErrorMessage from '../ErrorMessage';
import PaymentAddButton from '../Payment/PaymentAddButton';

const ActivateDomainPaymentTab = ({ domain }) => {
  const [error, setError] = useState();
  const fetch = useFetch();

  const addPayment = () => {
    fetch(`/api/admin/accounts/${domain.accountId}/paymentMethod/authorization`, {
      method: 'POST',
      body: JSON.stringify({}),
    })
      .then(({ url }) => {
        window.location.replace(url);
      })
      .catch(setError);
  };

  return (
    <>
      <ErrorMessage message={error?.message} />
      <Flex justify="center" pb="xl">
        <Grid.Col span={{ base: 12, md: 6 }}>
          <Title order={5}>Please add your payment method now to ensure uninterrupted service at the end of your trial.</Title>
        </Grid.Col>
      </Flex>
      <Flex justify="center" pb="xl">
        <Grid.Col span={{ base: 12, md: 6 }}>
          <PaymentAddButton addPayment={addPayment} />
        </Grid.Col>
      </Flex>
      <Flex justify="center">
        <Grid.Col span={{ base: 12, md: 6 }}>
          <p>
            <Text span fw={700} c="dimmed">
              Your subscriptions include a{' '}
              {domain.domainSubscriptions.find((s) => s.status === 'active')?.type === 'modular' ? 10 : 30}-day trial.
              You may cancel at any time during your trial and you will not be charged.
            </Text>
          </p>
        </Grid.Col>
      </Flex>
    </>
  );
};

export default ActivateDomainPaymentTab;
